export default __webpack_public_path__ + "static/media/vipera.e108871d.png";